import React from 'react'

import PersonCoverageModal from 'components/PersonCoverageModal'

const VISION_COVERAGE_DESCRIPTION =
  'We’ll calculate your vision plan pricing based on who you want to cover. Use the checkboxes and click “Save” to make any changes.'

const VisionCoverageModal = (props) => (
  <PersonCoverageModal description={VISION_COVERAGE_DESCRIPTION} {...props} />
)

VisionCoverageModal.displayName = 'VisionCoverageModal'

export default VisionCoverageModal
